<i18n>
  {
    "en": {
      "references": {
        "title": "References"
      }
    },
    "fr": {
      "references": {
        "title": "Références"
      }
    }
  }
</i18n>
<template>
  <div class="l-content">
    <div class="row">
      <div class="col-xs-16 col-xs-offset-1 col-sm-14 col-sm-offset-2">
        <div class="references">
          <h5 v-html="$t('references.title')"></h5>
          <ul>
            <slot></slot>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'References',
  props: ['title']
}
</script>
<style lang="scss" scoped>
.references {
  color: #9FA0A4;
  margin-bottom: 60px;
  // padding-bottom: 120px;
  h5 {
    margin: 24px 0 16px 0;
    font-size: 15px;
    font-weight: 500;
  }
  ul {
    list-style: none;
    padding: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/References.vue